import React, { useEffect, useState, forwardRef } from "react";
import { TextField } from "@mui/material";
import "../../theme-vars.css";
import { styled } from "@mui/material/styles";

type Props = {
  title: string;
  style?: React.CSSProperties;
  validator?: (value: string) => string;
  length?: boolean;
  disabled?: boolean;
  value?: string;
  required?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const primaryColor = "#292744";
const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor: "#f7f8fa",
    fontSize: "var(--font-size-medium)",
    fontFamily: "var(--font-family-main)",
    "& fieldset": {
      borderColor: "#bfc7d5",
    },
    "&:hover fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`,
    },
    "&.Mui-focused fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`,
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px",
    fontSize: "var(--font-size-medium)",
    color: "#222",
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
    fontSize: "var(--font-size-medium)",
    color: primaryColor,
  },
  "& .MuiInputLabel-root.Mui-required .MuiInputLabel-asterisk": {
    color: "#d32f2f", // red color for required asterisk
  },
});

const InputTextValue = forwardRef<HTMLInputElement, Props>(
  ({ title, style, validator, disabled, value = "", required, onChange },ref) => {
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
      if (validator) {
        setErrorMsg(validator(value));
      }
    }, [value, validator]);

    return (
      <CustomTextField
        label={title}
        fullWidth
        required={required}
        variant="outlined"
        value={value}
        onChange={(e: any) => {
          onChange?.(e);
          if (validator) {
            setErrorMsg(validator(e.target.value));
          }
        }}
        onBlur={() => {
          if (validator) {
            setErrorMsg(validator(value));
          }
        }}
        error={!!errorMsg}
        helperText={errorMsg}
        InputLabelProps={{
          style: {
            color: "#555",
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-medium)",
          },
        }}
        InputProps={{
          style: {
            color: "#222",
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-medium)",
          },
        }}
        disabled={disabled}
        sx={style}
      />
    );
  }
);

export default InputTextValue;
